import { QUERY_KEYS } from 'api/query-keys';
import { flexPoolService, workersPoolsService } from 'ogp/services';
import { useQuery } from 'react-query';
import { useAlert } from 'shared/components/alerts';

export type AvailableFlexWorkerForPool = { id: string; email: string };

export enum FlexpoolType {
  Internal = 'internal',
  External = 'external',
}

export const useGetAvailableFlexWorkersForPool = (
  flexpoolType: FlexpoolType,
  poolId: string,
  filter: string
) => {
  const { alertError } = useAlert();

  const queryKey =
    flexpoolType === FlexpoolType.Internal
      ? QUERY_KEYS.flexPoolAvailableWorkers(poolId, filter)
      : QUERY_KEYS.externalWorkersPoolAvailable(poolId, filter);

  const queryFn = async (): Promise<AvailableFlexWorkerForPool[]> => {
    if (flexpoolType === FlexpoolType.Internal) {
      return await flexPoolService.getAvailableFlexWorkers(poolId, filter);
    } else if (flexpoolType === FlexpoolType.External) {
      return await workersPoolsService.getAvailableWorkersForWorkersPool(poolId, filter);
    }
    throw flexpoolType satisfies never;
  };

  return useQuery<AvailableFlexWorkerForPool[], Error, AvailableFlexWorkerForPool[]>(
    queryKey,
    queryFn,
    {
      enabled: poolId.length > 0 && filter.length >= 3,
      keepPreviousData: true,
      staleTime: Infinity,
      onError: (e) => alertError(e),
    }
  );
};
